import { SubmitHandler, useForm } from 'react-hook-form';

import { useDrawerContext } from '../../../components/Drawer/Context';
import { FormValues } from './types';

export interface UseTileIntroductionForm {
  onNext: (data: FormValues) => Promise<void> | void;
}

const useTileIntroductionForm = ({ onNext }: UseTileIntroductionForm) => {
  const { onClose } = useDrawerContext();

  const formMethods = useForm<FormValues>({
    defaultValues: {
      doNotShowAgain: false,
    },
  });

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    await onNext(data);
  };

  return { formMethods, onSubmit, onClose };
};

export default useTileIntroductionForm;
